export const siteInfo = {
  name: '麻花影视',
  slogan: '汇聚多元影视频道，发现你的专属片单',
  description: '麻花影视精心整合四虎影视、影视飓风、番茄影视、大叔影视、桃花影视等十余个特色影视频道的优质内容，一站式满足悬疑烧脑、硬核科普、轻松喜剧、温情治愈等不同观影口味。每日更新热点追踪，高清流畅不缓冲，为挑剔的影迷打造个性化观影入口。',
};

export const navItems = [
  { label: '热门榜单', href: '#ranking' },
  { label: '移动观影', href: '#app' },
  { label: '焦点专题', href: '#carousel' },
  { label: '精选推荐', href: '#cards' },
  { label: '影迷热评', href: '#comments' },
];

export const heroStats = [
  { label: '合作频道', value: '15+' },
  { label: '日更内容', value: '200+' },
  { label: '高清流畅', value: '1080P' },
];

export const features = [
  {
    icon: 'ri-stack-line',
    title: '多频道聚合',
    description: '四虎影视、影视飓风、番茄影视、大叔影视等特色频道一站收录，不用来回切换平台，打开麻花影视就能浏览全网热门内容。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速高清体验',
    description: '全站支持 1080P 高清画质，智能 CDN 加速确保播放流畅不缓冲，无论电脑还是手机都能享受影院级观影体验。',
  },
  {
    icon: 'ri-fire-line',
    title: '每日热点追踪',
    description: '实时捕获各频道最新上架与热搜内容，桃花影视的新剧、大象影视的纪录片、草民影视的独立佳作，不错过任何精彩。',
  },
];

export const carouselItems = [
  {
    title: '四虎影视 · 悬疑烧脑专场',
    description: '精选四虎影视本月最受好评的悬疑推理大片，《隐秘的角落》同款质感，层层反转让你欲罢不能。从经典本格推理到社会派悬疑，一次看过瘾。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20mystery%20thriller%20visual%20with%20dark%20alley%20at%20night%2C%20warm%20street%20lamp%20glow%2C%20rain%20soaked%20pavement%2C%20silhouette%20of%20a%20detective%20figure%2C%20film%20noir%20aesthetic%2C%20rich%20amber%20and%20deep%20charcoal%20tones%2C%20cinematic%20lighting%2C%20moody%20atmosphere&width=800&height=500&seq=mahua-carousel-01&orientation=landscape',
    tag: '热门推荐',
  },
  {
    title: '影视飓风 · 硬核科普季',
    description: '影视飓风最新系列带你深入电影特效幕后，从绿幕抠像到 CG 合成，揭开好莱坞大片的制作秘密。电影爱好者的知识盛宴，每一帧都是干货。',
    image: 'https://readdy.ai/api/search-image?query=A%20movie%20production%20behind%20the%20scenes%20scene%20with%20professional%20camera%20equipment%2C%20green%20screen%20studio%2C%20lighting%20rigs%2C%20a%20director%20chair%2C%20warm%20studio%20lighting%2C%20cinematic%20production%20atmosphere%2C%20professional%20film%20making%20vibe&width=800&height=500&seq=mahua-carousel-02&orientation=landscape',
    tag: '深度解析',
  },
  {
    title: '番茄影视 · 喜剧合家欢',
    description: '番茄影视爆笑喜剧大合集温暖上线，从国产喜剧新势力到经典重温，轻松欢乐陪你度过每一个需要笑声的夜晚。全家老少一起看，笑声不断。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20family%20living%20room%20with%20a%20large%20TV%20screen%2C%20colorful%20decorations%2C%20popcorn%20bowls%2C%20warm%20evening%20light%20through%20curtains%2C%20joyful%20and%20relaxed%20home%20cinema%20atmosphere%2C%20bright%20and%20cheerful%20vibe&width=800&height=500&seq=mahua-carousel-03&orientation=landscape',
    tag: '轻松时刻',
  },
  {
    title: '大叔影视 · 经典怀旧厅',
    description: '大叔影视带你重温那些年的经典港片和内地佳作，周星驰全集、王家卫美学、张艺谋色彩，每一部都是时代的记忆。这里有最懂电影的大叔陪你聊。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20vintage%20cinema%20interior%20with%20red%20velvet%20curtains%2C%20classic%20film%20posters%20on%20walls%2C%20warm%20golden%20lighting%2C%20retro%20film%20projector%2C%20old%20school%20movie%20theater%20charm%2C%20rich%20amber%20and%20burgundy%20tones&width=800&height=500&seq=mahua-carousel-04&orientation=landscape',
    tag: '经典重温',
  },
];

export const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20photo%20of%20a%20young%20Chinese%20man%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20soft%20natural%20lighting%2C%20clean%20and%20modern%20look&width=80&height=80&seq=mahua-avatar-01&orientation=squarish',
    name: '影迷小李',
    time: '2 小时前',
    content: '之前要在四虎影视和番茄影视之间来回切换找片，麻花影视直接把所有频道整合在一起了，太方便了！桃花影视的新剧更新速度也很快，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20photo%20of%20a%20young%20Chinese%20woman%2C%20warm%20smile%2C%20simple%20neutral%20background%2C%20soft%20studio%20lighting%2C%20clean%20natural%20look&width=80&height=80&seq=mahua-avatar-02&orientation=squarish',
    name: '追剧达人阿雯',
    time: '5 小时前',
    content: '影视飓风的科普内容质量真的高，以前在别的地方看总是缓冲，麻花影视的高清体验完全不一样。大叔影视的经典片库也是宝藏，周星驰全集在这里找到了！',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20photo%20of%20a%20middle%20aged%20Chinese%20man%2C%20gentle%20expression%2C%20simple%20warm%20background%2C%20soft%20lighting%2C%20natural%20and%20approachable%20look&width=80&height=80&seq=mahua-avatar-03&orientation=squarish',
    name: '老电影爱好者',
    time: '昨天',
    content: '草民影视的独立电影和大象影视的纪录片在其他平台很难找到，麻花影视把这些小众精品都收进来了，对真正的影迷来说简直是天堂。画质也很给力，支持！',
    rating: 5,
  },
];

export const updates = [
  {
    date: '2026-07-31',
    title: '桃花影视最新都市情感剧《城市之光》全网上线',
    description: '桃花影视年度重磅都市情感剧今日独家上线麻花影视，讲述三位都市女性在事业与爱情中的成长故事。',
    tag: '新剧上线',
  },
  {
    date: '2026-07-30',
    title: '四虎影视悬疑剧场更新《暗夜追踪》大结局',
    description: '备受关注的悬疑剧《暗夜追踪》迎来大结局，所有谜底全部揭晓，四虎影视会员可抢先观看完整版。',
    tag: '热播收官',
  },
  {
    date: '2026-07-29',
    title: '影视飓风发布《流浪地球3》特效幕后全纪录',
    description: '影视飓风独家探班《流浪地球3》特效团队，揭秘国产科幻大片背后令人惊叹的视觉特效制作全过程。',
    tag: '独家揭秘',
  },
  {
    date: '2026-07-28',
    title: '番茄影视喜剧新片《笑到停不下来》票房破亿',
    description: '番茄影视出品的喜剧电影上映一周票房突破一亿，成为今年暑期档最大黑马，麻花影视同步上线高清版。',
    tag: '票房捷报',
  },
  {
    date: '2026-07-27',
    title: '大叔影视经典港片修复计划启动，首批 50 部',
    description: '大叔影视宣布启动经典港片 4K 修复计划，首批 50 部包括《大话西游》《无间道》等，麻花影视将同步更新。',
    tag: '经典新生',
  },
  {
    date: '2026-07-26',
    title: '大象影视自然纪录片《极地生灵》获国际大奖',
    description: '大象影视出品的自然纪录片《极地生灵》荣获国际纪录片节最佳摄影奖，麻花影视独家提供幕后花絮。',
    tag: '荣誉时刻',
  },
  {
    date: '2026-07-25',
    title: '草民影视独立短片展映周开启，12 部佳作免费看',
    description: '草民影视联合麻花影视推出独立短片展映周，精选 12 部青年导演佳作，限时免费观看，支持中国独立电影。',
    tag: '限时活动',
  },
];

export const indexItems = [
  { title: '四虎影视', description: '悬疑推理 · 犯罪剧情', icon: 'ri-movie-line' },
  { title: '影视飓风', description: '科普解析 · 幕后揭秘', icon: 'ri-lightbulb-line' },
  { title: '番茄影视', description: '轻松喜剧 · 合家欢', icon: 'ri-emotion-laugh-line' },
  { title: '大叔影视', description: '经典重温 · 怀旧专场', icon: 'ri-vidicon-line' },
  { title: '桃花影视', description: '都市情感 · 女性视角', icon: 'ri-heart-line' },
  { title: '大象影视', description: '纪录片 · 自然人文', icon: 'ri-earth-line' },
  { title: '草民影视', description: '独立电影 · 文艺佳作', icon: 'ri-leaf-line' },
  { title: '麻豆影视', description: '短剧精选 · 快节奏', icon: 'ri-flashlight-line' },
  { title: '全部频道', description: '浏览全部 15+ 合作频道', icon: 'ri-grid-line' },
];

export const cardItems = [
  {
    title: '本月最热：四虎影视《深渊凝视》',
    description: '年度悬疑神作，豆瓣 9.2 分，烧脑程度拉满。四虎影视独家上线，高清画质沉浸式观影体验。',
    image: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20cinematic%20scene%20with%20a%20person%20standing%20at%20the%20edge%20of%20a%20dark%20cliff%20overlooking%20a%20foggy%20city%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20rich%20contrast%20between%20warm%20and%20cool%20tones&width=600&height=400&seq=mahua-card-01&orientation=landscape',
    tag: '悬疑',
    channel: '四虎影视',
  },
  {
    title: '影视飓风：AI 如何改变电影工业',
    description: '深度解析 AI 技术在电影制作中的应用，从剧本创作到特效渲染，影视飓风带你看见未来。',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20film%20studio%20with%20holographic%20displays%2C%20computer%20screens%20showing%203D%20rendering%2C%20warm%20ambient%20lighting%2C%20modern%20technology%20and%20cinema%20fusion%2C%20clean%20professional%20workspace&width=600&height=400&seq=mahua-card-02&orientation=landscape',
    tag: '科普',
    channel: '影视飓风',
  },
  {
    title: '番茄影视：《家有儿女》新篇回归',
    description: '经典情景喜剧全新回归番茄影视，原班人马再聚首，熟悉的配方全新的笑点，家庭观影首选。',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20cheerful%20family%20living%20room%20scene%20with%20warm%20sunlight%2C%20colorful%20decor%2C%20sofa%20and%20TV%2C%20happy%20family%20atmosphere%2C%20cozy%20and%20inviting%20home%20vibe%2C%20Chinese%20family%20aesthetic&width=600&height=400&seq=mahua-card-03&orientation=landscape',
    tag: '喜剧',
    channel: '番茄影视',
  },
  {
    title: '桃花影视：《三十而立》女性群像剧',
    description: '桃花影视年度女性群像大剧，三个女人在三十岁的门槛上重新定义人生，真实动人引发共鸣。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20scene%20with%20three%20women%20walking%20through%20a%20sunlit%20city%20street%2C%20stylish%20casual%20outfits%2C%20warm%20golden%20hour%20lighting%2C%20confident%20and%20graceful%20vibe%2C%20contemporary%20Chinese%20city%20aesthetic&width=600&height=400&seq=mahua-card-04&orientation=landscape',
    tag: '都市',
    channel: '桃花影视',
  },
  {
    title: '大象影视：《丝绸之路》史诗纪录片',
    description: '大象影视历时三年拍摄的大型纪录片，沿着古丝绸之路探寻文明交汇的故事，每一帧都是壁纸。',
    image: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20landscape%20of%20ancient%20silk%20road%20desert%20with%20camel%20caravan%20at%20sunset%2C%20golden%20sand%20dunes%2C%20warm%20amber%20sky%2C%20epic%20cinematic%20scale%2C%20documentary%20style%20photography%2C%20rich%20earthy%20tones&width=600&height=400&seq=mahua-card-05&orientation=landscape',
    tag: '纪录片',
    channel: '大象影视',
  },
];

export const rankingItems = [
  { rank: 1, title: '深渊凝视', channel: '四虎影视', tag: '悬疑', hot: '9.2' },
  { rank: 2, title: '城市之光', channel: '桃花影视', tag: '都市', hot: '8.9' },
  { rank: 3, title: '笑到停不下来', channel: '番茄影视', tag: '喜剧', hot: '8.7' },
  { rank: 4, title: '特效幕后全纪录', channel: '影视飓风', tag: '科普', hot: '8.6' },
  { rank: 5, title: '极地生灵', channel: '大象影视', tag: '纪录片', hot: '8.5' },
  { rank: 6, title: '暗夜追踪', channel: '四虎影视', tag: '悬疑', hot: '8.4' },
];

export const mediaItems = [
  {
    title: '《深渊凝视》终极预告',
    description: '四虎影视年度悬疑大作，三分钟预告带你进入迷雾重重的犯罪世界。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20scene%20with%20a%20single%20spotlight%20illuminating%20a%20figure%20on%20stage%2C%20surrounded%20by%20deep%20shadows%2C%20dramatic%20theater%20lighting%2C%20mysterious%20and%20tense%20atmosphere%2C%20film%20noir%20aesthetic&width=640&height=360&seq=mahua-media-01&orientation=landscape',
    duration: '03:12',
    channel: '四虎影视',
  },
  {
    title: '影视飓风：绿幕魔法大揭秘',
    description: '从拍摄到合成，五分钟看懂绿幕特效的完整工作流程，大开眼界。',
    image: 'https://readdy.ai/api/search-image?query=A%20film%20studio%20with%20green%20screen%20setup%2C%20professional%20lighting%20equipment%2C%20camera%20on%20tripod%2C%20behind%20the%20scenes%20of%20movie%20production%2C%20warm%20studio%20lighting%2C%20professional%20cinematic%20vibe&width=640&height=360&seq=mahua-media-02&orientation=landscape',
    duration: '05:28',
    channel: '影视飓风',
  },
  {
    title: '大叔影视：周星驰经典片段混剪',
    description: '从《大话西游》到《功夫》，十分钟重温星爷的经典笑点与泪点。',
    image: 'https://readdy.ai/api/search-image?query=A%20classic%20Hong%20Kong%20style%20comedy%20scene%20with%20vibrant%20colors%2C%20retro%20Chinese%20street%20market%20background%2C%20warm%20nostalgic%20film%20grain%20aesthetic%2C%20playful%20and%20lively%20atmosphere%2C%2090s%20Hong%20Kong%20cinema%20vibe&width=640&height=360&seq=mahua-media-03&orientation=landscape',
    duration: '10:45',
    channel: '大叔影视',
  },
  {
    title: '大象影视：北极冰川实拍日记',
    description: '摄制组在零下 40 度的北极圈拍摄的珍贵画面，每一秒都震撼人心。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20arctic%20landscape%20with%20massive%20glaciers%20and%20icy%20blue%20waters%2C%20polar%20bears%20in%20distance%2C%20crystal%20clear%20light%2C%20pristine%20natural%20beauty%2C%20documentary%20photography%20style%2C%20epic%20scale&width=640&height=360&seq=mahua-media-04&orientation=landscape',
    duration: '08:20',
    channel: '大象影视',
  },
];

export const aboutInfo = {
  title: '关于麻花影视',
  description1: '麻花影视是一个专注于影视内容聚合与分发的在线平台，致力于为影迷打造一站式的个性化观影体验。我们与四虎影视、影视飓风、番茄影视、大叔影视、桃花影视、大象影视、草民影视等十余个特色内容频道深度合作，覆盖悬疑推理、硬核科普、轻松喜剧、经典怀旧、都市情感、自然纪录、独立文艺等多种类型。',
  description2: '我们的团队由一群热爱电影和技术的伙伴组成，每天精心筛选各频道最新、最热、最优质的内容，确保每一位来到麻花影视的用户都能快速找到自己喜欢的影片。高清画质、流畅播放、智能推荐，是我们不变的追求。无论你是悬疑迷、喜剧控还是纪录片爱好者，麻花影视都是你最好的观影伴侣。',
};

export const topicItems = [
  { name: '悬疑推理', count: '2.3k', icon: 'ri-search-eye-line' },
  { name: '国产喜剧', count: '1.8k', icon: 'ri-emotion-happy-line' },
  { name: '科幻大片', count: '1.6k', icon: 'ri-rocket-line' },
  { name: '都市情感', count: '1.5k', icon: 'ri-heart-pulse-line' },
  { name: '经典港片', count: '1.4k', icon: 'ri-film-line' },
  { name: '自然纪录', count: '1.2k', icon: 'ri-landscape-line' },
  { name: '独立电影', count: '980', icon: 'ri-award-line' },
  { name: '电影科普', count: '860', icon: 'ri-lightbulb-flash-line' },
  { name: '短剧精选', count: '750', icon: 'ri-smartphone-line' },
  { name: '女性视角', count: '680', icon: 'ri-women-line' },
  { name: '动画动漫', count: '620', icon: 'ri-ghost-line' },
];

export const faqItems = [
  {
    question: '麻花影视是否需要注册才能观看？',
    answer: '麻花影视目前提供完全免费的浏览和观看服务，无需注册即可直接访问所有频道内容。你可以在首页浏览热门推荐、查看各频道最新更新，点击感兴趣的内容即可开始观看，全程高清流畅不卡顿。',
  },
  {
    question: '四虎影视、番茄影视等频道的内容是否同步更新？',
    answer: '是的，麻花影视与各合作频道保持紧密的同步机制。四虎影视、桃花影视、番茄影视等频道的新内容上线后，我们会在最短时间内完成同步，确保你不会错过任何最新剧集和电影。每日更新动态可以在"快讯"区域查看。',
  },
  {
    question: '支持的画质有哪些？手机端观看体验如何？',
    answer: '麻花影视全站内容默认支持 1080P 高清画质，部分内容提供 4K 选项。移动端已做全面适配，在手机浏览器中打开即可获得与桌面端同样流畅的观影体验，智能码率调整确保在不同网络环境下都能流畅播放。',
  },
  {
    question: '如何找到特定类型的影片？',
    answer: '你可以通过首页的频道索引快速进入感兴趣的内容分区，如悬疑推理（四虎影视）、科普解析（影视飓风）、轻松喜剧（番茄影视）等。也可以浏览话题标签区域，通过悬疑、喜剧、纪录片等标签发现更多相关内容。',
  },
  {
    question: '内容是否支持下载离线观看？',
    answer: '目前麻花影视以在线流媒体播放为主，保障高清流畅的实时观看体验。我们正在评估离线下载功能的技术方案，未来可能会在特定频道中推出，敬请关注快讯区域的更新动态。',
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '如果你有任何观影建议、频道合作意向或内容反馈，欢迎随时与我们取得联系。麻花影视团队期待听到每一位影迷的声音，你的每一个建议都可能让平台变得更好。',
};